import { JobApplicationType } from '../../../domain/types';
import { removeNullAndUndefinedValues } from '../../../utils/array';
import { BooleanString, booleanStringToBool } from '../../../utils/boolean-string/booleanString';
import { JobApplicationSerpFiltersFormModel } from '../../components/job-application-serp-filters-form/JobApplicationSerpFiltersForm';
import { SerpJobApplicationAdvancedFilters } from './types';
import { FiltersMapper } from '../../../hooks/use-filters/useFilters';
import { Agent, Name } from '../../../providers/api/dtos/agent';
import getShortAgentName from '../../../utils/agent/getShortAgentName';
import { jobApplicationHrUsers } from '../../constants';
import { CustomUser } from '../../../types';
import { getCustomUserShortName } from '../../../providers/api/auth/getCustomUserShortName';
import { UserFilterParam } from '../../../hooks/use-filters/params/userFilterParam';

const getId = (user: Agent | CustomUser) => {
  if ('id' in user) {
    return user.id;
  }

  return undefined;
};

const getShortName = (user: Agent | CustomUser) => {
  if (typeof user.name === 'object') {
    return getShortAgentName(user.name as Name);
  }
  return getCustomUserShortName(user as CustomUser);
};

export const serpJobApplicationAdvancedFiltersMapper: FiltersMapper<SerpJobApplicationAdvancedFilters> = {
  type: (value) => (value ? value as JobApplicationType : undefined),
  jobPositionId: (value) => (value ? value.split(',') : undefined),
  province: (value) => (value ? value.split(',') : undefined),
  supervisorEmail: (value) => (value ? value.split(',').map((it) => UserFilterParam.fromQueryParam(it)) : undefined),
  assigneeEmail: (value) => (value ? value.split(',').map((it) => UserFilterParam.fromQueryParam(it)) : undefined),
  interviewerEmail: (value) => (value ? value.split(',').map((it) => UserFilterParam.fromQueryParam(it)) : undefined),
  source: (value) => value,
  isFranchising: (value) => (value ? booleanStringToBool(value as BooleanString) : undefined),
  hasLicense: (value) => (value ? booleanStringToBool(value as BooleanString) : undefined),
  createdAtGt: (value) => value,
  createdAtLt: (value) => value,
};

export const jobApplicationSerpFiltersFormModelToAdvancedFilters = (formModel: JobApplicationSerpFiltersFormModel) => {
  const supervisorEmails = removeNullAndUndefinedValues(formModel.supervisorEmails.map((email) => {
    const user = jobApplicationHrUsers.find((u) => u.email === email);
    return user ? new UserFilterParam(user?.email, getShortName(user), undefined) : undefined;
  }));
  const assigneeInterviewerEmails = removeNullAndUndefinedValues(formModel.assigneeInterviewers).map((filter) => {
    const email = typeof filter.email === 'string' ? filter.email : (filter as Agent).email.work!;
    const name = getShortName(filter);
    return new UserFilterParam(email, name, getId(filter));
  });

  return {
    type: formModel.type || undefined,
    jobPositionId: formModel.jobPositionIds,
    province: formModel.provinces,
    supervisorEmail: supervisorEmails,
    assigneeEmail: assigneeInterviewerEmails,
    interviewerEmail: assigneeInterviewerEmails,
    createdAtGt: formModel.createdAtFrom ? new Date(formModel.createdAtFrom).toISOString() : undefined,
    createdAtLt: formModel.createdAtTo ? new Date(formModel.createdAtTo).toISOString() : undefined,
    source: formModel.source || undefined,
    isFranchising: booleanStringToBool(formModel.isFranchising),
    hasLicense: booleanStringToBool(formModel.hasLicense),
  };
};
